import { ga4AddProduct, ga4RemoveProduct } from './EventService';

export const eventTripAddToCart = (trip, searchPorts) => {
  ga4AddProduct(trip, searchPorts);
};

export const eventTripRemoveFromCart = (trip, searchPorts) => {
  ga4RemoveProduct(trip, searchPorts);
};
